import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: null,
  struConfigId: null,
  clientStoreHash: null,
  channelMapping: {}

};

export const getConfig = createAsyncThunk(
  "getConfig",
  async (storeHash) => {
    try {
      const response = await fetch(`/api/getStoreConfig/${storeHash}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch config");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getConfig",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getConfig.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getConfig.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.data = action.payload.data.data;
        state.struConfigId = action.payload.data.data.struConfigId;
        state.clientStoreHash = action.payload.data.data?.targetClientDomain;
        if (action.payload.data.data.basicFilter !== null) {
          state.channelMapping = action.payload.data.data.basicFilter.channelMapping;
        }
      })
      .addCase(getConfig.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
